export default function contact(){
    return(
        <div>Contact Us
For support or queries:
Email: jobsniperteam@gmail.com
Location: Chennai, India
This is the official support channel for JobSniper.</div>
    )
}